import { axios, base } from '../http';

export const getDailyRecipeList = (params) => {
  return axios.get(`${base}/api/Dish/GetDailyRecipeList`, { params: params }).then(res => res.data);
};

// 获取每日食谱详情（按批次ID?

export const getDailyRecipeDetail = (params) => {
  return axios.get(`${base}/api/Dish/GetDailyRecipeDetail`, { params: params }).then(res => res.data);
};

// 保存每日食谱

export const saveDailyRecipe = (params) => {
  return axios.post(`${base}/api/Dish/SaveDailyRecipe`, params).then(res => res.data);
};

// 删除每日食谱 (整批)

export const deleteDailyRecipe = (params) => {
  return axios.delete(`${base}/api/Dish/DeleteDailyRecipe`, { params: params }).then(res => res.data);
};

// 删除每日食谱明细 (单项)

export const deleteDailyRecipeDetail = (params) => {
  return axios.delete(`${base}/api/Dish/DeleteDailyRecipeDetail`, { params: params }).then(res => res.data);
};

// 部门树前端内存缓存，TTL = 5 分钟，避免同一会话内重复传输 6MB+ 响应体

export const getDishCategoryListPage = (params) => {
  return axios.get(`${base}/api/DishCategory/get`, { params: params });
};

//编辑菜品分类

export const editDishCategory = (params) => {
  return axios.put(`${base}/api/DishCategory/put`, params);
};
//新增菜品分类

export const addDishCategory = (params) => {
  return axios.post(`${base}/api/DishCategory/post`, params);
};
//删除菜品分类

export const deleteDishCategory = (params) => {
  return axios.delete(`${base}/api/DishCategory/Delete`, { params: params });
};

//获取菜品

export const getDishListPage = (params) => {
  return axios.get(`${base}/api/Dish/get`, { params: params });
};

//菜品统计

export const getDishStatistics = (params) => {
  return axios.get(`${base}/api/Dish/StatOrderByDay`, { params: params });
};

//导出订餐统计Excel

export const exportDayStatExcel = (params) => {
  return axios.get(`${base}/api/Dish/ExportDayStatExcel`, {
    params: params,
    responseType: "blob", // 指定响应类型�?blob
  });
};

//根据部门ID获取订餐配置

export const getOrderFoodConfig = (params) => {
  return axios.get(`${base}/api/Dish/GetOrderFoodConfig`, { params: params });
};

//保存订餐配置

export const saveOrderFoodConfig = (params) => {
  return axios.post(`${base}/api/Dish/SaveOrderFoodConfig`, params);
};

//根据部门ID获取课程配置

export const editDish = (params) => {
  return axios.put(`${base}/api/Dish/put`, params);
};
//新增菜品

export const addDish = (params) => {
  return axios.post(`${base}/api/Dish/post`, params);
};
//删除菜品

export const deleteDish = (params) => {
  return axios.delete(`${base}/api/Dish/Delete`, { params: params });
};

//根据设备号查询菜品配�?


//保存设备菜品配置


//获取菜品下拉列表

export const getDishList = (params) => {
  return axios.get(`${base}/api/Dish/GetList`, { params: params });
};

//获取请假申请记录

export const getOrderStatsByDepartment = (params) => {
  return axios.get(`${base}/api/Dish/GetOrderStatsByDepartment`, {
    params: params,
  });
};

// 后台批量退订

export const batchCancelOrderStat = (orderStatIds) => {
  return axios.post(`${base}/api/Dish/BatchCancelOrderStat`, orderStatIds);
};

// 导出部门订餐统计及明�?

export const exportOrderStatsByDepartment = (params) => {
  return axios.get(`${base}/api/Dish/ExportOrderStatsByDepartment`, {
    params: params,
    responseType: "blob",
  });
};

// 请假退餐登记：明细分页（仅已生效）。创建于 2026-10-05
export const getLeaveMealRefundDetailPage = (params) => {
  return axios.get(`${base}/api/LeaveMealRefund/GetDetailPage`, { params: params });
};

// 请假退餐登记：汇总
export const getLeaveMealRefundSummary = (params) => {
  return axios.get(`${base}/api/LeaveMealRefund/GetSummary`, { params: params });
};

// 请假退餐登记：所选部门所在学校的餐次
export const getLeaveMealRefundDinnerTimes = (params) => {
  return axios.get(`${base}/api/LeaveMealRefund/GetDinnerTimes`, { params: params });
};

// 请假退餐登记：批量同意
export const approveLeaveMealRefund = (data) => {
  return axios.post(`${base}/api/LeaveMealRefund/Approve`, data);
};

// 请假退餐登记：批量拒绝
export const rejectLeaveMealRefund = (data) => {
  return axios.post(`${base}/api/LeaveMealRefund/Reject`, data);
};

// 请假退餐登记：删除记录
export const deleteLeaveMealRefund = (data) => {
  return axios.post(`${base}/api/LeaveMealRefund/Delete`, data);
};

// 请假退餐：学校级时段规则
export const getLeaveMealRefundWindowRules = (params) => {
  return axios.get(`${base}/api/LeaveMealRefundWindowRule/Get`, { params: params });
};

export const saveLeaveMealRefundWindowRules = (schoolId, data) => {
  return axios.post(`${base}/api/LeaveMealRefundWindowRule/Save?schoolId=${schoolId}`, data);
};

// 请假退餐登记：导出明细
export const exportLeaveMealRefundDetail = (params) => {
  return axios.get(`${base}/api/LeaveMealRefund/ExportDetail`, {
    params: params,
    responseType: "blob",
  });
};

// 请假退餐登记：导出汇总
export const exportLeaveMealRefundSummary = (params) => {
  return axios.get(`${base}/api/LeaveMealRefund/ExportSummary`, {
    params: params,
    responseType: "blob",
  });
};

// 导出组织活动Excel
